module.exports = __webpack_public_path__ + "img/5.90d6f3a5.jpg";